import { Box, Stack } from '@mui/material';
import React from 'react';
import { Letter } from './Letter';

type PropTypes = {
  correctAnswer: boolean;
  underline: boolean;
  timerLimitReached: boolean;
  unrevealedIndex?: number[];
  word: string[];
  wordIndex: number;
};

export const Word = ({
  correctAnswer,
  underline,
  timerLimitReached,
  unrevealedIndex,
  word,
  wordIndex,
}: PropTypes) => {
  return (
    <>
      {word.map((letter, letterIndex) =>
        letter === ' ' ? (
          <div key={`letter-${letterIndex}`}></div>
        ) : (
          <div key={`letter-${letterIndex}`}>
            <Letter
              correctAnswer={correctAnswer}
              letter={letter}
              letterIndex={letterIndex}
              timerLimitReached={timerLimitReached}
              underline={underline}
              unrevealedIndex={unrevealedIndex}
              wordIndex={wordIndex}
            ></Letter>
          </div>
        )
      )}
    </>
  );
};
